import { Component, inject } from "@angular/core";
import { IWorkflow } from "../../interfaces/i-workflow";
import { ApiService } from "../../../../services/api.service";
import { AlertService } from "../../../../shared/alert/alert.service";
import { SpinnerService } from "../../../../shared/spinner/spinner.service";
import { WorkflowTableComponent } from "../workflow-table/workflow-table.component";
import { AlertEnum } from "../../../../shared/alert/alert.enum";
import { MatButtonModule } from "@angular/material/button";
import { AutomationAction, AutomationType } from "../../enums/automation.enum";
import { AutomationUtilityService } from "../../services/automation-utility.service";

@Component({
  selector: "app-my-workflows",
  imports: [
    WorkflowTableComponent,
    MatButtonModule
  ],
  providers: [
    AutomationUtilityService
  ],
  templateUrl: "./my-workflows.component.html",
  styleUrl: "./my-workflows.component.scss",
})
export class MyWorkflowsComponent {
  gridData: IWorkflow[] = [];
  isLoading = true;

  #apiService = inject(ApiService);
  #alertService = inject(AlertService);
  #spinnerService = inject(SpinnerService);
  #automationUtilityService = inject(AutomationUtilityService);

  constructor() {
    this.#spinnerService.show();
    this.#apiService.getMyWorkflows().subscribe({
      next: workflows => {
        this.gridData = workflows;
        this.#spinnerService.hide();
        this.isLoading = false;
      },
      error: (error: any) => {
        this.#spinnerService.hide();
        this.#alertService.showAlert({
          message: `Failed to get all workflows.`,
          type: AlertEnum.error,
        });
        this.isLoading = false;
      }
    });
  }

  /**
   * Creates a new workflow.
   */
  onCreate(): void {
    this.#automationUtilityService.createItem(AutomationType.WORKFLOW, AutomationAction.CREATE);
  }
}
